import { useTheme } from "@emotion/react";
import React from "react";
import CcList from "../ccList";
import { CcIcon } from "../ccIcon";

export const Details = ({ data }) => {
  const theme = useTheme();

  const headingStyle = {
    fontFamily: theme.font.primary,
    margin: "9px 0 36px",
  };

  const detailStyle = {
    color: theme.colors.primary,
    display: "flex",
    alignItems: "center",
    fontWeight: 600,
    paddingLeft: 36,
    "svg": {
      width: "1.5em",
      flexShrink: 0,
      marginRight: 10,
    }
  };

  return (
    <>
      <h2 css={headingStyle}>{data.title || "Call or email us"}</h2>
      <CcList>
        {data.fields.map((item, index) => {
          return (
            <div css={detailStyle} key={index}>
              {item.detailType ? <CcIcon name={item.detailType} /> : null}
              {item.detailValue}
            </div>
          )
        })}
      </CcList>
    </>
  );
};
